<script setup>
defineProps({
  left: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="floating-bee" :class="{ left: left }">
    <img
      src="/assets/images/shared/bee-1.png"
      alt="WebBees Logo"
      class="webbees-logo webbees-logo-light"
    />
    <img
      src="/assets/images/shared/bee-2.png"
      alt="WebBees Logo"
      class="webbees-logo webbees-logo-dark"
    />
    <span>powered by <b>WebBees</b></span>
  </div>
</template>

<style lang="scss" scoped>
// create style where the bee logo floats in the lower right corner of the screen
.floating-bee {
  position: fixed;
  bottom: 1rem;
  right: 2rem;
  z-index: 1000;
  height: 3rem;
  background-color: #fff;
  border-radius: 3rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  cursor: pointer;

  padding: 0.5rem 1rem 0.75rem;

  &:hover {
    transform: scale(1.1);
  }

  & > .webbees-logo {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  & > span {
    font-size: 0.8rem;
  }

  & > * + * {
    margin-left: 0.5rem;
  }
}

.floating-bee.left {
  left: 2rem;
  right: auto;
}

html.dark .floating-bee {
  background-color: #272727;
  color: #f1f5f9;

  box-shadow: none;
}

html.dark .webbees-logo-light {
  display: none;
}

html:not(.dark) .webbees-logo-dark {
  display: none;
}
</style>
